import { useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'

import DetallePago from '../../pedidos/DetallePago'
import DetallePie from '../../pedidos/DetallePie'
import Descripcion from '../../publicaciones/Descripcion'
import DetalleCabecera from '../../publicaciones/DetalleCabecera'
import * as mensajesService from '../../servicios/mensajesService'
import * as pedidosService from '../../servicios/pedidosService'
import * as ventasService from '../../servicios/ventasService'
import BordeDetalle from '../../ui/BordeDetalle'
import DetalleCobro from '../../ventas/DetalleCobro'
import { DetalleEstadoPedido } from '../../ventas/DetalleEstadoPedido'
import { MensajeriaNew } from '../mensajeria/MensajeriaNew'

export const PedidoDetalle = () => {
  const usuario = parseInt(localStorage.getItem('idUsuario'))
  const { idPedidoItem } = useParams()

  const navigate = useNavigate()

  const [mensajes, setMensajes] = useState([])
  const [pedido, setPedido] = useState({})
  const [esVentas, setEsVentas] = useState(false)
  const [estados, setEstados] = useState([])

  const buscarMensajes = async (idComprador) => {
    try {
      const { data } = await mensajesService.buscarPorPedidoItem(
        idPedidoItem,
        idComprador ?? pedido.idComprador
      )
      setMensajes(
        data.sort((a, b) => new Date(a.fechaEscrito) - new Date(b.fechaEscrito))
      )
    } catch {
      setMensajes([])
    }
  }

  const buscarPedido = async () => {
    try {
      const pedidoResp = (await pedidosService.buscarPorPedidoItem(idPedidoItem)).data
      setEsVentas(pedidoResp.idVendedor === usuario)
      setEstados(pedidoResp.estados)
      const pedidoAux = {
        ...pedidoResp.pedidoItems[0],
        fechaPedido: pedidoResp.fechaPedido,
        idComprador: pedidoResp.idComprador,
        idPedido: pedidoResp.idPedido
      }
      setPedido(pedidoAux)

      buscarMensajes(pedidoResp.idComprador)
    } catch {
      setPedido({})
    }
  }

  const actualizarPedido = async () => {
    const respuesta = await ventasService.buscarPorUsuario(pedido.idVendedor, '')
    if (respuesta?.data) {
      const pedidoActualizado = respuesta.data.find(
        (item) => item.idPedidoItem === parseInt(idPedidoItem)
      )
      if (pedidoActualizado) {
        setPedido(pedidoActualizado)
      }
    }
  }

  useEffect(() => {
    buscarPedido()
  }, [])

  const navegar = () => {
    const navegarA = esVentas ? '/Ventas' : '/Pedidos'
    navigate(navegarA)
  }

  return (
    Object.keys(pedido).length > 0 && (
      <BordeDetalle titulo={'Detalle Compras'} onCerrarClick={() => navegar()}>
        <DetalleCabecera detalle={pedido} esVentas={esVentas} permiteComprar={false} />
        <Descripcion descripcion={pedido.descripcion} />
        <DetallePago fechaPedido={pedido.fechaPedido} pedidoItem={pedido} />
        {esVentas && (
          <>
            <DetalleEstadoPedido
              pedido={pedido}
              estados={estados}
              onActualizar={actualizarPedido}
            />
            <DetalleCobro
              cantidad={pedido?.cantidad}
              precio={pedido?.precioUnitario}
              porcentajeComision={pedido?.comision}
              precioExposicion={pedido?.precioExposicion}
              exposicion={pedido?.exposicion}
              monedaSimbolo={pedido?.monedaSimbolo}
            />
            <hr />
          </>
        )}
        <MensajeriaNew
          titulo={'Mensajería interna'}
          id={idPedidoItem}
          tipoDoc={'pedido'}
          idVendedor={pedido.idVendedor}
          idComprador={pedido.idComprador || usuario}
          mensajes={mensajes}
          tipoMensajes={'chat'}
          usuario={usuario}
          actualizarMensajes={buscarMensajes}
        />
        <DetallePie esVentas={esVentas} />
      </BordeDetalle>
    )
  )
}
